import { ChakraFlex as Flex, ChakraHeading as Heading } from "@airhelp/react-ui-components";
import dynamic from "next/dynamic";
import type { CircularProgressProps } from "./CircularProgress.d";

const Circle0 = dynamic(() => import("./ProgressCircles").then((mod) => mod.Circle0));
const Circle35 = dynamic(() => import("./ProgressCircles").then((mod) => mod.Circle35));
const Circle50 = dynamic(() => import("./ProgressCircles").then((mod) => mod.Circle50));
const Circle65 = dynamic(() => import("./ProgressCircles").then((mod) => mod.Circle65));
const Circle100 = dynamic(() => import("./ProgressCircles").then((mod) => mod.Circle100));

const progressCircle = {
  0: <Circle0 />,
  35: <Circle35 />,
  50: <Circle50 />,
  65: <Circle65 />,
  100: <Circle100 />,
};

const CircularProgress = ({ progressValue }: CircularProgressProps) => {
  if (!progressCircle[progressValue]) {
    return null;
  }

  return (
    <Flex width="200px" align="center" justify="center">
      {progressCircle[progressValue]}
      <Heading variant="h3" as="h3" textAlign="left" position="absolute">
        {progressValue}%
      </Heading>
    </Flex>
  );
};

export default CircularProgress;
